exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-module-create-modal .module-create-modal__header{justify-content:flex-end;padding:.75rem}.fts-module-create-modal .module-create-modal__body{padding:0 1.5rem 1.5rem}.fts-module-create-modal .module-create-form{padding-top:1rem}.fts-module-create-modal .module-create-emoji-wrapper{margin-bottom:1rem;text-align:center}.fts-module-create-modal .module-create-emoji{display:inline-flex}", ""]);

// exports
